import ApiService from '../../services/api.service';

export default {
  namespaced: true,
  state: {
    isLoading: true,
    dmaActionItem: {},
    defaultActionItem: {
      action_item_1: '',
      action_item_2: '',
      action_item_3: '',
      action_item_1_responsible: '',
      action_item_2_responsible: '',
      action_item_3_responsible: '',
      action_item_1_planned_date: null,
      action_item_2_planned_date: null,
      action_item_3_planned_date: null,
      action_item_1_completed_date: null,
      action_item_2_completed_date: null,
      action_item_3_completed_date: null,
    },
  },

  mutations: {
    SET_ACTION_ITEM(state, value) {
      state.dmaActionItem = value;
    },
    RESET_ACTION_ITEM(state) {
      state.dmaActionItem = { ...state.defaultActionItem };
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
  },

  actions: {
    async checkExisting({ commit }, currentDealership) {
      commit('SET_LOADING', true);
      let params = {
        'q[dealer_id_eq]': currentDealership.id,
        'q[s]': 'created_at desc',
      };
      await ApiService.query('dma_action_items', { params })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            commit('SET_ACTION_ITEM', response.data[0]);
          } else {
            commit('RESET_ACTION_ITEM');
          }
        })
        .catch(() => {
          commit('RESET_ACTION_ITEM');
        });
      commit('SET_LOADING', false);
    },

    async saveActionItem({ state, dispatch }, currentDealership) {
      if (state.dmaActionItem.id) {
        await ApiService.update(`dma_action_items`, state.dmaActionItem.id, {
          dma_action_item: state.dmaActionItem,
        }).then(() => {
          dispatch('checkExisting', currentDealership);
        });
      } else {
        let params = { ...state.dmaActionItem };
        params.dealer_id = currentDealership.id;

        await ApiService.post('dma_action_items', {
          dma_action_item: params,
        }).then(() => {
          dispatch('checkExisting', currentDealership);
        });
      }
      return state.dmaActionItem;
    },
  },
};
